import { $g } from '../../utils/global';
import { $storage } from '../../utils/storage';
import { $cookie } from '../../utils/cookie';
export const getters = {
    collapsed: (state) => {
        let collapsed = state.collapsed;
        if (collapsed === null)
            collapsed = $storage.get($g.caches.storages.collapsed);
        return collapsed;
    },
    opens: (state) => {
        return state.opens;
    },
    active: (state) => {
        return state.active;
    },
    drawer: (state) => {
        return state.drawer;
    },
    mobile: (state) => {
        return state.mobile;
    },
    theme: (state) => {
        let theme = state.theme;
        theme = theme === null ? theme : $cookie.get($g.caches.cookies.theme);
        return theme;
    },
    routes: (state) => {
        let routes = state.routes;
        if (Object.keys(routes).length <= 0) {
            routes = JSON.parse($storage.get($g.caches.storages.routes) ?? '{}');
        }
        return routes;
    }
};
